module.exports = __webpack_public_path__ + "img/cdown.02f7ee61.png";